var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecycleBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9537 20.2434L12.8118 18.1016L14.9537 15.9597C15.2331 15.6803 15.2331 15.2241 14.9537 14.9447C14.6744 14.6654 14.2181 14.6654 13.9388 14.9447L11.7969 17.0866L9.655 14.9447C9.37564 14.6654 8.91939 14.6654 8.64003 14.9447C8.36067 15.2241 8.36067 15.6803 8.64003 15.9597L10.7819 18.1016L8.64003 20.2434C8.36067 20.5228 8.36067 20.9791 8.64003 21.2584C8.91939 21.5378 9.37564 21.5378 9.655 21.2584L11.7969 19.1165L13.9388 21.2584C14.2181 21.5378 14.6744 21.5378 14.9537 21.2584C15.2331 20.9791 15.2331 20.5228 14.9537 20.2434Z",
    fill: "#E63335",
    stroke: "#E63335",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71429 27.4286C1.71429 29.3143 3.25714 30.8571 5.14286 30.8571H18.8571C20.7429 30.8571 22.2857 29.3143 22.2857 27.4286V10.2857C22.2857 8.4 20.7429 6.85714 18.8571 6.85714H5.14286C3.25714 6.85714 1.71429 8.4 1.71429 10.2857V27.4286ZM6.85714 10.2857H17.1429C18.0857 10.2857 18.8571 11.0571 18.8571 12V25.7143C18.8571 26.6571 18.0857 27.4286 17.1429 27.4286H6.85714C5.91429 27.4286 5.14286 26.6571 5.14286 25.7143V12C5.14286 11.0571 5.91429 10.2857 6.85714 10.2857ZM18 1.71429L16.7829 0.497143C16.4743 0.188571 16.0286 0 15.5829 0H8.41714C7.97143 0 7.52571 0.188571 7.21714 0.497143L6 1.71429H1.71429C0.771429 1.71429 0 2.48571 0 3.42857C0 4.37143 0.771429 5.14286 1.71429 5.14286H22.2857C23.2286 5.14286 24 4.37143 24 3.42857C24 2.48571 23.2286 1.71429 22.2857 1.71429H18Z",
    fill: "#E63335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecycleBin);
export default __webpack_public_path__ + "static/media/RecycleBin.700d46aa99dc347a144e3df21fe4b00a.svg";
export { ForwardRef as ReactComponent };